// Wishlist Preferences v2 — Sponsorship Category multi-select (Feb 2026).
// Thin wrapper around CatalogMultiSelect that pre-wires:
//   • endpoint:        GET /catalog/sponsorship-categories
//   • label rendering: localised label_es | label_en
//   • soft auto-migration of legacy free-text CSV values: any value the
//     user had stored in `sponsorship_categories` that is NOT a catalog
//     slug gets moved into `custom_sponsorship_category_other` on first
//     render (handled by CatalogMultiSelect's migrated effect).

import React from "react";
import CatalogMultiSelect from "./CatalogMultiSelect";

const renderSponsorshipLabel = (it, lang) => {
  if (lang === "es" && it.label_es) return it.label_es;
  return it.label_en || it.key;
};

export const SponsorshipCategoryMultiSelect = ({
  value,
  customValue,
  onChange,
  onCustomChange,
  t,
  lang = "en",
}) => {
  return (
    <CatalogMultiSelect
      endpoint="/catalog/sponsorship-categories"
      value={value || []}
      customValue={customValue || []}
      onChange={onChange}
      onCustomChange={onCustomChange}
      renderLabel={(it) => renderSponsorshipLabel(it, lang)}
      filterParamKey="group"
      filterValue=""
      t={t}
      testIdPrefix="wlp-sponsor"
      label={t("settings.wishlistV2.sponsorshipCategories.label")}
      placeholder={t("settings.wishlistV2.sponsorshipCategories.placeholder")}
      searchPlaceholder={t("settings.wishlistV2.sponsorshipCategories.searchPlaceholder")}
      searchEmpty={t("settings.wishlistV2.sponsorshipCategories.searchEmpty")}
      otherLabel={t("settings.wishlistV2.sponsorshipCategories.otherLabel")}
      otherPlaceholder={t("settings.wishlistV2.sponsorshipCategories.otherPlaceholder")}
    />
  );
};

export default SponsorshipCategoryMultiSelect;
